export { NavigationProfile } from "./src/navigation-profile/navigation-profile";
